import { useContext, useEffect } from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import { fetchAcademicFields, validateSections } from 'actions';
import { Nothing } from 'components/Nothing/Nothing';
import type { RootState } from 'reducers/types';
import { useTranslations } from 'utils/translations/useTranslations';

import { TranslationContext } from 'contexts/TranslationContext/TranslationContext';
import type { Field } from 'models/field';
import type { Section as SectionModel } from 'models/section';
import { getSectionsByEntity, isEmbedded } from '../../selectors';
import { Section } from '../SectionList/Section/Section';

type PropsFromRedux = ConnectedProps<typeof connector>;
type AcademicFieldsProps = PropsFromRedux & {
  section?: SectionModel<Field>[];
};
const ENTITY = 'academic';

const AcademicFieldsComponent = ({
  fetchAcademicFields,
  section,
  isEmbedded,
}: AcademicFieldsProps) => {
  const i18n = useTranslations();
  const translationContext = useContext(TranslationContext);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    fetchAcademicFields(i18n);
  }, [fetchAcademicFields, translationContext.keys]);

  if (isEmbedded) {
    return <Nothing />;
  }

  const sectionTyped = section?.[0] as unknown as SectionModel<Field>[];

  return <>{sectionTyped && <Section fields={[]} {...sectionTyped} />}</>;
};

const mapStateToProps = (state: RootState) => ({
  sections: getSectionsByEntity(state, ENTITY),
  isEmbedded: isEmbedded(state),
});

const mapDispatchToProps = {
  validateSections,
  fetchAcademicFields,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

const AcademicFields = connector(AcademicFieldsComponent);

export { AcademicFields };
